'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Control to ask for passenger info (for all passengers).
// Note that passenger fields are also asked in winresReservationCustomerInfo
// if the customer is a passenger.
//
// To edit the view for individual passenger fields, see passengerFields.js
var WinresReservationPassengerInfoController = function () {
    function WinresReservationPassengerInfoController($scope) {
        _classCallCheck(this, WinresReservationPassengerInfoController);

        this.ready = false;
        this.passengerErrors = {};
        this.$scope = $scope;
    }

    _createClass(WinresReservationPassengerInfoController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            var data = this.winresReservationContext.getContext();
            if (data.mustWaitDeparture) {
                console.log('[WRPI]', 'Waiting until the departure has loaded.');
                var unwatch = this.$scope.$watch(function () {
                    return data.mustWaitDeparture;
                }, function (mwd) {
                    if (mwd) return;
                    console.log('[WRPI]', 'The departure has loaded.');
                    unwatch();
                    _this.initInternal();
                    _this.ready = true;
                });
            } else {
                this.initInternal();
                this.ready = true;
            }
        }
    }, {
        key: 'initInternal',
        value: function initInternal() {
            var _this2 = this;

            // Dependencies
            // this.winresReservationContext

            // Get:
            // getContext()
            // getContext().Passengers
            // getContext().NumAdults
            // getContext().NumChildren
            // getContext().NumInfants
            // getContext().getPassengerDisplayNames()
            // getForceGender()
            // getMinChildren()
            // getMaxChildren()
            // getPassengerFields()
            // getSeoState()
            // getOwnerData()

            // Set:
            // getContext().Passengers()
            // setReservationComponentErrors()

            // Other:

            this.data = this.winresReservationContext.getContext();

            this.Fields = this.winresReservationContext.getPassengerFields();

            // isInitial - try to parse from Session whether the user has already
            // changed anything on the form.
            var isInitial = (_typeof(this.data.Passengers) !== 'object' || this.data.Passengers == null) && !this.data.NumAdults;

            if (isInitial) {
                this.informLater = false;
            } else {
                // informLater (i.e. enter only passenger amounts) is inferred from
                // sessio data, if data.Passengers is not set.
                this.informLater = !this.data.Passengers;
            }

            this.$scope.$watch('$ctrl.informLater', function (informLater) {
                if (informLater) {
                    console.log('[WRPI]', 'Passenger information will be asked later. Deleting all passengers for now.');
                    _this2.data.Passengers = null;
                } else if (!_this2.data.Passengers) {
                    console.log('[WRPI]', 'Passenger information will be asked now, but there are no passengers. Creating a list with one passenger. Previous list:', _this2.data.Passengers);
                    _this2.data.Passengers = [];
                    _this2.addPassenger();
                }
                // No need to validate, since passengers changes and will be
                // validated then (on the next iteration)
            });

            this.$scope.$watchGroup(['$ctrl.data.NumAdults', '$ctrl.data.NumChildren', '$ctrl.data.NumInfants'], function () {
                _this2.removeProductsFromMissingPassengers();
                _this2.validate();
            });
            this.$scope.$watch('$ctrl.data.Passengers', function (passengers) {
                if (passengers) {
                    _this2.data.NumAdults = 0;
                    _this2.data.NumChildren = 0;
                    _this2.data.NumInfants = 0;
                    //console.log('passengernames', this.passengerNames);
                    _.each(passengers, function (passenger) {
                        switch (passenger.Gender) {
                            case 'CH':
                            case 'CH/F':
                            case 'CH/M':
                                _this2.data.NumChildren++;
                                break;
                            case 'IN':
                            case 'IN/F':
                            case 'IN/M':
                                _this2.data.NumInfants++;
                                break;
                            default:
                                _this2.data.NumAdults++;
                        }
                    });
                    _this2.passengerNames = _this2.winresReservationContext.getPassengerDisplayNames();
                }
                _this2.validate();
            }, true);

            this.$scope.$on('i18nextLanguageChange', function () {
                _this2.passengerNames = _this2.winresReservationContext.getPassengerDisplayNames();
            });

            // passengerErrors is set by the passengerFields subcomponent.
            this.$scope.$watch('$ctrl.passengerErrors', function () {
                _this2.validate();
            }, true);

            this.fieldWidths = {
                FirstName: this.widthFirstName,
                LastName: this.widthLastName,
                Gender: this.widthGender
            };
        }
    }, {
        key: 'addPassenger',
        value: function addPassenger() {
            // The passenger is open (not collapsed) when adding new, so the user
            // can enter the details right away.
            var passenger = { IsOpen: true };
            var forceGender = this.winresReservationContext.getForceGender();
            if (forceGender) {
                passenger.Gender = forceGender;
            }
            this.data.Passengers.push(passenger);
        }
    }, {
        key: 'deletePassenger',
        value: function deletePassenger(index) {
            this.data.Passengers.splice(index, 1);
            // Remove passenger assignments (hytitys) of the passenger.
            _.each(this.data.Products, function (product) {
                if (product.PassengerAssignments) {
                    _.remove(product.PassengerAssignments, function (o) {
                        return o.PassengerNumber == index;
                    });
                    // Renumber existing assignments (passenger might have been
                    // removed from the middle thus all passengers after that have
                    // their passenger number decremented.
                    _.each(product.PassengerAssignments, function (amount) {
                        if (amount.PassengerNumber >= index) {
                            amount.PassengerNumber--;
                        }
                    });
                }
            });
        }
    }, {
        key: 'removeProductsFromMissingPassengers',
        value: function removeProductsFromMissingPassengers() {
            // Clear product assignments (hytitys) targeting passengers that do not
            // exist.
            // This is usually done when a passenger is removed by decrementing the
            // passenger count in the mode where passenger information is not
            // entered.
            // The case where passenger is removed by the delete button is handled
            // by the deletePassenger function.
            var numPassengers = this.data.NumAdults + this.data.NumChildren + this.data.NumInfants;
            _.each(this.data.Products, function (productLine) {
                _.remove(productLine.PassengerAssignments, function (o) {
                    return o.PassengerNumber >= numPassengers;
                });
                if (productLine.PassengerAssignments && productLine.Product.DestinationInfo.ProductType != 'HU' && productLine.Product.DestinationInfo.ProductType != 'HY') {
                    // Do not update amounts for cabins, since tha cabins may still
                    // have passengers.
                    productLine.Amount = productLine.PassengerAssignments.length;
                }
            });
        }
    }, {
        key: 'validate',
        value: function validate() {
            var _this3 = this;

            var errors = [];
            var numPassengers = this.data.NumAdults + this.data.NumChildren + this.data.NumInfants;
            // If only the passenger count is entered, check that it's greater
            // than zero.
            if (this.informLater) {
                if (this.data.NumAdults < 0 || this.data.NumChildren < 0 || this.data.NumInfants < 0) {
                    errors.push('common.generic_error');
                }
                if (numPassengers <= 0) {
                    errors.push('reservation_passenger.error_must_add_passengers');
                }
            } else {
                // Case where passenger names are entered.
                if (this.data.Passengers.length == 0) {
                    errors.push('reservation_passenger.error_must_add_passengers');
                }
                _.each(this.passengerErrors, function (passengerErrors, passengerIndex) {
                    if (passengerIndex >= _this3.data.Passengers.length) {
                        return;
                    }
                    if (passengerErrors && passengerErrors.length) {
                        errors = errors.concat(passengerErrors);
                    }
                });
            }

            // Require children (min. number of children can be enforced e.g. by
            // winresReservationCustomSelects, as done in Bottas for Family
            // Duathlon where at least one child is required.)
            if (this.winresReservationContext.getMinChildren() > this.data.NumChildren) {
                // Pluralization of error message.
                if (this.winresReservationContext.getMinChildren() > 1) {
                    errors.push({
                        Message: 'reservation_passenger.error_need_at_least_n_children',
                        Params: {
                            min: this.winresReservationContext.getMinChildren()
                        } });
                } else {
                    errors.push('reservation_passenger.error_need_at_least_1_child');
                }
            }

            this.winresReservationContext.setReservationComponentErrors('passenger', 'passengers', errors);
        }
    }, {
        key: 'canAddPassenger',
        value: function canAddPassenger() {
            if (this.canAddPassengers === 'false') {
                return false;
            }
            if (this.informLater) {
                // Hide the add button in the mode where only number of passengers
                // is entered.
                return false;
            }
            // Don't allow adding above maximum. If max is not set, it means there
            // is no maximum.
            var max = this.winresReservationContext.getMaxPassengers();
            return !max || this.data.Passengers.length < max;
        }
    }, {
        key: 'canDeletePassenger',
        value: function canDeletePassenger(passenger) {
            if (this.canDeletePassengers === 'false') {
                return false;
            }
            if (passenger.IsLocked) {
                // If the customer is a passenger, that passenger is locked in this
                // control.
                return false;
            }
            // Don't allow deleting below minimum.
            return this.data.Passengers.length > this.winresReservationContext.getMinPassengers();
        }
    }]);

    return WinresReservationPassengerInfoController;
}();

WinresReservationPassengerInfoController.$inject = ['$scope'];

function getTemplate($attrs, $sce) {
    return $attrs.templateUrl ? $sce.trustAsResourceUrl((0, _utils.getWebcomponentsUrl)($attrs.templateUrl)) : 'passengerInfo';
}

getTemplate.$inject = ['$attrs', '$sce'];

_module3.default.run(['$templateCache', function ($templateCache) {
    $templateCache.put('passengerInfo', require('./winresReservationPassengerInfo.html'));
}]);

_module3.default.component('winresReservationPassengerInfo', {
    templateUrl: getTemplate,
    controller: WinresReservationPassengerInfoController,
    require: {
        winresReservationContext: '^^winresReservationContext'
    },
    bindings: {
        requirePassengerDetails: '@', // If 'true', users cannot only enter the passenger count
        showContinueButton: '@', // Show the "Jatka" / "Continue" button below the form.
        mode: '@', // 'full', 'single-line'. Default: 'full'
        showAlways: '@',
        canDeletePassengers: '@', // Default true
        canAddPassengers: '@', // Default true
        showHeader: '@', // 'true' / 'false' - default true
        deletePassengerText: '@', // Default: 'reservation_customer.delete_person',
        addPassengerText: '@',
        showDeletePassengerIcon: '@', // true or false - default true
        showErrorGroup: '@', // shows errors from specific locale-group, ie. all reservation_passenger.xxxxxx errors. If null, errors won't be displayed. Add also to winresReservationButton.js

        //Widths of fields in columns (if you add fields here, add them to
        //                             $onInit also)
        widthFirstName: '@',
        widthLastName: '@',
        widthGender: '@',

        //changes this field to be the first field displayed, if multiple separate with comma without spaces. Last specified will be first to displayed
        firstField: '@',
        //separate with comma (,)
        removeField: '@',
        // if true: displays attendee instead of traveller
        useAttendee: '@',

        // Countries shown first in country selection. First country in list is set to passenger.
        // Seperate countries by comma ex. "FI,SE,RU"
        countryOrder: '@',

        // List only ETA countries
        etaCountries: '@'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresReservationPassengerInfo/winresReservationPassengerInfo.js
// module id = 371
// module chunks = 2